export const ApplicationRoutes = {
  Auth: '/auth',
  Cabinet: '/',
};
